module.exports = __webpack_public_path__ + "static/data-32bef24ddd89a4c3a8a9fdd032a2b94f.png";